/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackOfficeConfigDto } from '../../models/back-office-config-dto';

export interface GetConfig$Params {
  'X-API-Version'?: string;
}

export function getConfig(http: HttpClient, rootUrl: string, params?: GetConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<BackOfficeConfigDto>> {
  const rb = new RequestBuilder(rootUrl, getConfig.PATH, 'get');
  if (params) {
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BackOfficeConfigDto>;
    })
  );
}

getConfig.PATH = '/api/config';
